import { Bookmark } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgBookmark = mkIcon(Bookmark);